export default "__VITE_ASSET__Do$h4eoy__"